import { useParams } from "react-router";
import { RowDetail } from "../components/entity/RowDetail";
import { RowDetailBreadcrumb } from "../components/entity/RowDetailBreadcrumb";
import { useChatScope } from "../hooks/use-chat-scope";

/**
 * Sprint 12 — the shareable full-page row view at /entities/:typeSlug/:rowId.
 * Renders the same `<RowDetail>` as the slide-in panel, in `page` mode (wider,
 * two-column at desktop widths). Reached via the panel's "Open as full page"
 * button or a direct/shared URL.
 *
 * Sprint 12b — a breadcrumb + back affordance sits above the content so the user
 * always knows where they are and how to return to the table.
 */
export function RowDetailFullPage() {
  const { typeSlug, rowId } = useParams<{ typeSlug: string; rowId: string }>();

  // Sprint 22 — scope the cockpit chat to this record. The chat runs at workspace
  // scope (root) with the row injected as page_context, so "update this account's
  // status" resolves against the right entity.
  useChatScope(
    typeSlug && rowId
      ? { kind: "entity", id: rowId, type_slug: typeSlug, label: `${typeSlug} ${rowId}` }
      : { kind: "workspace", label: "This workspace" },
    typeSlug && rowId ? { kind: "record", id: rowId, name: `${typeSlug} ${rowId}` } : null,
    [typeSlug, rowId],
  );

  if (!typeSlug || !rowId) {
    return (
      <div style={{ fontFamily: "var(--font-sans)", fontSize: 14, color: "var(--color-text-secondary)" }}>
        Record not found.
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", fontFamily: "var(--font-sans)" }}>
      <RowDetailBreadcrumb entityTypeSlug={typeSlug} entityId={rowId} />
      <RowDetail entityTypeSlug={typeSlug} entityId={rowId} mode="page" />
    </div>
  );
}
